export default {
  login: "Vui lòng đăng nhập để tiếp tục...",
  password_rule: "* Mật khẩu là chữ hoa và chữ thường và phải có độ dài từ 6 dến 10 ký tự.",
  nickname_rule:
    "* Bạn có thể đặt biệt danh để hiện thị và đăng nhập (6 đến 15 ký tự chữ và số). Vui lòng ghi chú lại rằng bạn có thể cài đặt biệt danh chỉ 1 lần duy nhất. Bạn không thể thay đổi hoặc huỷ bỏ biệt danh khi đã được cài đặt.",
  change_password_succeed: "Thay đổi mật khẩu thành công.",
  add_secondary_succeed: "Đặt biệt danh thành công.",
  succeed: "Thao tác thành công!",
  failed: "Thao tác thất bại!",
  no_information_available: "Thông tin không tồn tại.",
  select_display_language: "Chọn ngôn ngữ mặc định ưu thích của bạn.",
  select_odds_type: "Chọn hiển thị mặc định tỷ lệ cược loại ưa thích của bạn.",
  select_page_type: "Chọn loại trang ưa thích của bạn như mặc định để hiển thị trong cả ngày hôm nay và trang thị trường sớm.",
  select_show_score_map: "Kích hoạt tính năng hệ thống tự động hiển thị bản đồ điểm trong khi đặt cược.",
  select_default_event_sorting: "Chọn sự kiện mặc định ưu tiên sắp xếp hiển thị của bạn.",
  select_market_type: "Chọn thị trường ưa thích của bạn.",
  select_page_size: "Chọn kích thước trang ưa thích của bạn.",
  change_sports_menu_order: "Hãy kéo các môn thể thao để thay đổi thứ tự mong muốn của danh mục thể thao.",
  view_outstanding_bets_in_bet_list: "Các cược đang đợi có thể mất ít thời gian chấp nhận. Vui lòng vào mục Danh sách cược để xem các cược đang đợi mới nhất.",
  time_display_in_gmt_plus_8: "Thời gian trên được hiển thị với GMT+8.",
  select_default_stake: "Kích hoạt tính năng hệ thống tự động nhập tiền cược đã được điều chỉnh của bạn và lần cuối đặt cược .",
  bet_empty: "Phiêu cược của bạn trống. Vui lòng nhấp vào tỷ lệ cược trong bảng để lựa chọn đặt cược của bạn.",
  no_event: "Không có trận đấu hoặc trò chơi có sẵn bây giờ. Vui lòng truy cập các sự kiện thể thao hoặc trò chơi hoặc quay lại sau.",
  no_bets: "Không có mã cược đang chạy",
  no_waiting: "Không mã cược đang chờ",
  no_void: "Không có mã cược vô hiệu",
  odds_changed: "Tỷ giá thay đổi , làm mới tỷ giá ?",
  confirmation: "Bạn có xác nhận tiến hành đặt mã cược này không ?",
  olderversion: "Phiên bản hiện tại là phiên bản cũ , nhấn OK để tiến hành cập nhật hoặc nhấn Ctrl + F5.",
  gmt8: "Thời gian trên được hiển thị với GMT+8.",
  confirm_bet: "Xác nhận đặt cược?",

  login2: "Để đăng nhập và truy cập các trò chơi của chúng tôi, trước tiên bạn phải đăng ký một tài khoản. Nếu bạn đã có tài khoản, vui lòng tiếp tục đăng nhập.",

  days: "Ngày",
  hours: "Giờ",
  mins: "Phút",
  secs: "Giây",

  button_skip: "Bỏ qua hướng dẫn",
  button_previous: "Trước đó",
  button_next: "Tiếp theo",
  button_stop: "Hoàn thành",
  button_continue: "Tiếp tục",
};
